export { default as DotPagination } from "./DotPagination";
export { default as NumberedPagination } from "./NumberedPagination";

export * from "./Pagination";
export { default } from "./Pagination";
